import { render, staticRenderFns } from "./DisabledInputBox.vue?vue&type=template&id=1ecb9b6c&"
import script from "./DisabledInputBox.vue?vue&type=script&lang=js&"
export * from "./DisabledInputBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports